<template>
	<div class="template-pay">
		<van-nav-bar class="custom-nav-bar" :title="$t('recharge.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="page-content">
			<div class="account-card">
				<div class="account-header">
					<div class="account-title">{{ $t('assets.account_balance') }}</div>
					<div class="records-btn" @click="$router.push({path:'/RechargeList'});">
						<div class="records-btn-text">{{ $t('recharge.records_title') }}</div>
					</div>
				</div>

				<div class="account-balance">
					<div class="balance-amount">
						€{{ displayBalance }}
					</div>
				</div>

				<div class="account-desc">
					<div class="desc-text">
						{{ $t('recharge.random_amount_tip') }}
					</div>
				</div>
			</div>

			<div class="wallet-info">
				<div class="info-header">
					<div class="info-title">
						{{ $t('recharge.address_title') }}
					</div>
				</div>

				<div class="info-content">
					<div class="wallet-address">
						{{ usdtAddress || $t('recharge.wallet_address_empty') }}
					</div>
				</div>

				<div class="info-footer">
					<div class="copy-btn" @click="copyAddress">
						<div class="copy-btn-text">{{ $t('common.copy') }}</div>
					</div>
				</div>
			</div>

			<div class="amount-section">
				<div class="section-title">
					<div class="title-text">
						{{ $t('recharge.select_amount') }}
					</div>
				</div>

				<div class="con_number">
					<div v-for="amount in amountOptions" :key="amount" class="number"
						:class="{ active: selectedAmount === amount }" @click="selectAmount(amount)">
						€{{ amount }}
					</div>
				</div>

				<div class="custom-amount">
					<div class="custom-label">{{ $t('recharge.custom_amount') }}</div>
					<div class="custom-input">
						<div class="input-field">
							<input v-model.trim="money" type="number" :placeholder="$t('recharge.enter_amount')" />
						</div>
					</div>
				</div>
			</div>

			<div class="upload-section">
				<div class="section-title">
					<div class="title-text">
						{{ $t('recharge.upload_screenshot') }}
					</div>
				</div>
				<van-uploader v-model="fileList" class="tnimage" :max-count="1" :after-read="afterRead"
					:before-read="beforeRead" @delete="onDeleteFile">
					<span class="tn-icon-add"></span>
				</van-uploader>
			</div>
		</div>

		<div class="footerfixed">
			<div class="footerfixed-content">
				<div class="btn" :class="{ 'btn--disabled': uploading }" @click="onSubmit">
					{{ uploading ? $t('common.uploading') : $t('recharge.page_title') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import axios from "axios";
	import api from "../../http/api";
	import {
		Form,
		Field,
		Button
	} from "vant";
	const Base64 = require("js-base64").Base64;
	const API_BASE_URL = "https://shuadan-2.0.qpl-005.site/api";
	Vue.use(Form).use(Field).use(Button);

	export default {
		data() {
			return {
				userInfo: {},
				money: "",
				amountOptions: [100, 200, 300, 400, 500, 600],
				selectedAmount: "",
				fileList: [],
				voucherImg: "",
				uploading: false
			};
		},
		computed: {
			baseInfo() {
				return this.$store.getters.getBaseInfo || {};
			},
			usdtAddress() {
				return this.baseInfo.usdt_address || '';
			},
			qrCodeUrl() {
				return this.baseInfo.usdt_qrcode || '';
			},
			minRecharge() {
				const minRecharge = parseFloat(this.baseInfo.recharge_min);
				return Number.isNaN(minRecharge) ? 0 : minRecharge;
			},
			displayBalance() {
				const money = parseFloat(this.userInfo.money);
				return Number.isNaN(money) ? "0.00" : money.toFixed(2);
			}
		},
		watch: {
			money(value) {
				this.syncAmountState(value);
			}
		},
		created() {
			if (!localStorage.getItem("token")) {
				this.$router.push({
					path: "/Login"
				});
			} else {
				this.getUserInfo();
			}
		},
		methods: {
			back() {
				return window.history.back();
			},
			selectAmount(amount) {
				this.selectedAmount = amount;
				this.money = String(amount);
			},
			syncAmountState(value) {
				const money = String(value || "").trim();
				const matchedAmount = this.amountOptions.find((item) => String(item) === money);
				this.selectedAmount = matchedAmount || "";
			},
			formatImageUrl(url) {
				if (!url) {
					return "";
				}
				if (/^https?:\/\//i.test(url)) {
					return url;
				}
				return `https://shuadan-2.0.qpl-005.site${url}`;
			},
			getUploadHeaders() {
				return {
					token: localStorage.getItem("token") ? Base64.encode(localStorage.getItem("token")) : "",
					lang: localStorage.getItem("lang") || "de"
				};
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						if (this.userInfo.status !== 1) {
							this.$toast(this.$t("common.account_exception_relogin"));
							localStorage.clear();
							this.$router.push({
								path: '/Login'
							});
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			async copyAddress() {
				if (!this.usdtAddress) {
					this.$toast(this.$t("recharge.wallet_address_empty"));
					return;
				}
				try {
					await navigator.clipboard.writeText(this.usdtAddress);
					this.$toast(this.$t("recharge.wallet_address_copy_success"));
				} catch (err) {
					this.$toast(this.$t("recharge.wallet_address_copy_failed"));
				}
			},
			beforeRead(file) {
				const currentFile = Array.isArray(file) ? file[0] : file;
				const isImage = currentFile && /^image\//.test(currentFile.type || "");
				const fileName = currentFile && currentFile.name ? currentFile.name : "";
				const extension = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "";
				const allowExtensions = ["jpg", "jpeg", "png", "gif"];
				if (!isImage || allowExtensions.indexOf(extension) === -1) {
					this.$toast(this.$t("recharge.upload_image_only"));
					return false;
				}
				return true;
			},
			async afterRead(file) {
				const currentFile = Array.isArray(file) ? file[0] : file;
				if (!currentFile || !currentFile.file) {
					this.$toast(this.$t("recharge.voucher_upload_failed"));
					this.fileList = [];
					return;
				}
				const formData = new FormData();
				formData.append("file", currentFile.file);
				this.uploading = true;
				try {
					const response = await axios.post(api.recharge_upload_voucher, formData, {
						baseURL: API_BASE_URL,
						headers: {
							...this.getUploadHeaders(),
							"Content-Type": "multipart/form-data"
						}
					});
					const result = response.data || {};
					let data = result.data || "";
					if (data) {
						try {
							data = JSON.parse(Base64.decode(data));
						} catch (error) {
							data = "";
						}
					}
					if (result.code !== 200 || !data) {
						throw new Error(result.msg || this.$t("recharge.voucher_upload_failed"));
					}
					this.voucherImg = data;
					this.fileList = [{
						url: this.formatImageUrl(data),
						isImage: true
					}];
					this.$toast(this.$t("recharge.voucher_upload_success"));
				} catch (error) {
					this.fileList = [];
					this.voucherImg = "";
					this.$toast((error && error.message) || this.$t("recharge.voucher_upload_failed"));
				} finally {
					this.uploading = false;
				}
			},
			onDeleteFile() {
				this.voucherImg = "";
				this.fileList = [];
			},
			resetForm() {
				this.money = "";
				this.selectedAmount = "";
				this.voucherImg = "";
				this.fileList = [];
			},
			onSubmit() {
				if (this.uploading) {
					this.$toast(this.$t("recharge.voucher_uploading"));
					return;
				}
				if (!String(this.money).trim()) {
					this.$toast(this.$t("recharge.enter_amount"));
					return;
				}
				const money = parseFloat(this.money);
				if (Number.isNaN(money) || money <= 0) {
					this.$toast(this.$t("recharge.enter_valid_amount"));
					return;
				}
				if (this.minRecharge > 0 && money < this.minRecharge) {
					this.$toast(this.$t("recharge.min_amount_prefix") + this.minRecharge);
					return;
				}
				if (!this.voucherImg) {
					this.$toast(this.$t("recharge.upload_voucher_first"));
					return;
				}
				this.$http({
					method: "post",
					data: {
						money: money,
						voucher_img: this.voucherImg
					},
					url: "recharge",
				}).then((res) => {
					if (res.code === 200) {
						this.$toast(this.$t("recharge.submit_success"));
						this.resetForm();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
	};
</script>

<style lang='less' scoped>
	/* 页面容器 */
	.page-content {
		padding: 10px
	}

	/* 导航栏返回按钮 */
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 100px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		z-index: 9999 !important;
		position: relative !important;
		pointer-events: auto !important;
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .15);
		border-radius: 520px;
		border: 0.5px solid hsla(0, 0%, 100%, .5);
		color: #fff;
		font-size: 18px
	}

	.nav-bar__back .icon {
		pointer-events: auto !important
	}

	.nav-bar__back .icon {
		display: block;
		flex: 1;
		margin: auto;
		text-align: center
	}

	.nav-bar__back:before {
		content: " ";
		width: 0.5px;
		height: 110%;
		position: absolute;
		top: 22.5%;
		left: 0;
		right: 0;
		margin: auto;
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		pointer-events: none;
		box-sizing: border-box;
		opacity: .7;
		background-color: #fff
	}

	/* 账户信息卡片 */
	.account-card {
		background: linear-gradient(135deg, #d4aff9, #1f77d5);
		border-radius: 10px;
		padding: 15px;
		margin-bottom: 12px;
		color: #fff;
		box-shadow: 0 2px 10px rgba(31, 119, 213, .3)
	}

	.account-card .account-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px
	}

	.account-card .account-header .account-title {
		font-size: 14px;
		font-weight: 600
	}

	.account-card .account-header .records-btn {
		background: hsla(0, 0%, 100%, .2);
		padding: 5px 14px;
		border-radius: 12px;
		-webkit-backdrop-filter: blur(10px);
		backdrop-filter: blur(10px)
	}

	.account-card .account-header .records-btn .records-btn-text {
		font-size: 11px;
		font-weight: 500
	}

	.account-card .account-balance {
		margin-bottom: 8px
	}

	.account-card .account-balance .balance-amount {
		font-size: 24px;
		font-weight: 700
	}

	.account-card .account-desc .desc-text {
		font-size: 12px;
		opacity: .9
	}

	/* 钱包信息 */
	.wallet-info {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.wallet-info .info-header {
		margin-bottom: 8px
	}

	.wallet-info .info-header .info-title {
		font-size: 14px;
		font-weight: 600;
		color: #333
	}

	.wallet-info .info-content {
		margin-bottom: 10px;
		padding: 12px;
		background: #f8f9fa;
		border-radius: 6px
	}

	.wallet-info .info-content .wallet-address {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		word-break: break-all
	}

	.wallet-info .info-footer {
		display: flex;
		justify-content: center
	}

	.wallet-info .info-footer .copy-btn {
		width: 100%;
		padding: 10px 0;
		background: #000;
		border-radius: 6px;
		transition: all .3s ease
	}

	.wallet-info .info-footer .copy-btn:active {
		background: #333
	}

	.wallet-info .info-footer .copy-btn .copy-btn-text {
		font-size: 13px;
		font-weight: 600;
		color: #fff;
		text-align: center;
		display: block
	}

	/* 金额选择区域 */
	.amount-section {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.amount-section .section-title {
		margin-bottom: 10px
	}

	.amount-section .section-title .title-text {
		font-size: 14px;
		font-weight: 600;
		color: #333
	}

	.amount-section .con_number {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 12px
	}

	.amount-section .con_number .number {
		width: 31%;
		text-align: center;
		padding: 13px 0;
		font-size: 16px;
		font-weight: 600;
		border-radius: 6px;
		border: 1px solid #e8e8e8;
		margin-bottom: 8px;
		color: #333;
		transition: all .3s ease
	}

	.amount-section .con_number .number:active {
		-webkit-transform: scale(.98);
		transform: scale(.98)
	}

	.amount-section .con_number .active {
		background: linear-gradient(135deg, #d4aff9, #1f77d5);
		border: 1px solid #1f77d5;
		color: #fff
	}

	.amount-section .custom-amount .custom-label {
		display: block;
		font-size: 12px;
		color: #666;
		margin-bottom: 6px
	}

	.amount-section .custom-amount .custom-input {
		background: #f8f9fa;
		border-radius: 6px;
		padding: 0 10px
	}

	.amount-section .custom-amount .custom-input .input-field {
		width: 100%;
		height: 41px;
		font-size: 14px;
		color: #333
	}

	.amount-section .custom-amount .custom-input .input-field input {
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		text-decoration: inherit;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		position: relative;
		width: 100%;
		height: 100%;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	/* 上传截图区域 */
	.upload-section {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 62px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.upload-section .section-title {
		margin-bottom: 10px
	}

	.upload-section .section-title .title-text {
		font-size: 14px;
		font-weight: 600;
		color: #333;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.upload-section .tnimage {
		display: flex;
		align-items: center;
		justify-content: center
	}

	::v-deep .van-uploader__wrapper {
		align-items: center;
		justify-content: center;
		width: 104px;
		height: 104px;
		overflow: hidden;
		margin: 6px;
		margin-left: 0;
		background-color: #e6e6e6;
		position: relative;
		border-radius: 5px;
		flex-direction: column;
		color: #838383;
		font-size: 13px;
	}

	.tn-icon-add {
		font-size: 20px;
	}

	/* 底部悬浮按钮 */
	.footerfixed {
		display: -webkit-flex;
		display: flex;
		position: fixed;
		width: 100%;
		bottom: calc(5px + env(safe-area-inset-bottom));
		z-index: 1024;
		box-shadow: 0 -1px 6px rgba(0, 0, 0, .1);
		background: #fff;
		padding: 8px 10px;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px
	}

	.footerfixed-content {
		flex: 1;
		margin: 15px;
		text-align: center;
	}

	.btn {
		background-color: #3d7eff !important;
		color: #fff !important;
		box-shadow: 6px 6px 8px #d8e5ff;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		border-radius: 6px;
		margin: 0;
		padding: 20px 0px;
		font-size: 14px;
		height: 33px;
		width: 100%;
	}

	.btn--disabled {
		opacity: .7;
		pointer-events: none;
	}

	.btn::after {
		content: " ";
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid rgba(0, 0, 0, .2);
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 10px;
		border: none;
	}

	/* 图片上传样式 */
	.tn-image-upload__item {
		background-color: #f8f9fb;
		border-radius: 6px
	}

	::v-deep .van-uploader__preview-image {
		width: 104px;
		height: 104px;
	}

	::v-deep .van-uploader__input-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	::v-deep .van-uploader__preview-delete {
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0;
		right: 0;
		z-index: 10;
		border-top: 31px solid;
		border-left: 31px solid transparent;
		border-top-color: #e83a30;
		width: 0px;
		height: 0px;
		background-color: transparent;
		border-radius: 0;
	}

	::v-deep .van-uploader__preview-delete-icon {
		top: -26px;
		right: 3px;
		font-size: 12px;
		line-height: 1;
	}
</style>
